import React from 'react';
import './contact.css';
import Mail from '../../svg/Mail';
import Location from '../../svg/Location';
import Call from '../../svg/Call';
import emailjs from '@emailjs/browser';

function Contact() {

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_z4chy2g', 'template_jnu3x6d', e.target, 'user_9K39Uau0LixO1jkRl22bR')
        .then((result) => {
            console.log(result.text);
            alert('Your message is successfully send to Ashish Gupta. Will contact you in next 24hrs 😊');
            e.target.reset();
        }, (error) => {
            console.log(error.text);
            alert("Couldn't send mail. Please contact via call or whatsapp");
        });
    };

    return (
        <div className="contact-container" id="contact">
            <div className="map-container">
                <iframe title="home" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d471.03051503453145!2d72.82227618357634!3d19.184537024939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1618170127691!5m2!1sen!2sin" className="map" loading="lazy"></iframe>
            </div>

            <div className="contact-color-container"> 
                 <img src={process.env.PUBLIC_URL + '/image/icons/dot.png'} className="mini-dot" alt="Ashish Gupta"/>     
                 <img src={process.env.PUBLIC_URL + '/image/icons/light-star.png'} className="light-star" alt="Ashish Gupta"/> 
                 <img src={process.env.PUBLIC_URL + '/image/icons/light-star.png'} className="light-star star2" alt="Ashish Gupta"/>     
                 <img src={process.env.PUBLIC_URL + '/image/icons/light-triangle.png'} className="light-triangle" alt="Ashish Gupta"/> 
                 <img src={process.env.PUBLIC_URL + '/image/icons/light-triangle.png'} className="light-triangle triangle2" alt="Ashish Gupta"/>      
                 <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave" alt="Ashish Gupta"/>     
                 <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave wave2" alt="Ashish Gupta"/> 
                <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave wave3" alt="Ashish Gupta"/> 
                <img src={process.env.PUBLIC_URL + '/image/icons/light-wave.png'} className="light-wave wave4" alt="Ashish Gupta"/>    
                <div className="circle-fill"></div>
                
                <div className="box-fill"></div>
                <div className="box-mini-bar"></div>

            </div>
            {/* ***  Color-container end  ***** */}


            <div className="contact-section">
                <div className="section-flex">
                    <div className="section-left">
                        <h3>Get in Touch</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit explicabo animi deserunt molestiae iure aut, inventore eveniet, quisquam consectetur sed non dolore culpa officiis delectus. Ducimus atque pariatur id soluta.</p>

                        <div className="mini-flex">
                            <div className="mini-flex-left">
                                <div className="i-container">
                                    <Location className={"i"} />
                                </div>
                            </div>
                            <div className="mini-flex-right">
                                <h5>Plot No: 62, Room No:15, Gate No:7, <br/>
                                    NCC Malwani Malad west Mumbai 400095
                                </h5>
                            </div>
                        </div>

                        <div className="mini-flex">
                            <div className="mini-flex-left">
                                <div className="i-container">
                                    <Mail className={"i"} />
                                </div>
                            </div>
                            <div className="mini-flex-right">
                                <h5><a href="mailto: ag939431@gmail.com">ag939431@gmail.com</a></h5>
                            </div>
                        </div>

                        <div className="mini-flex">
                            <div className="mini-flex-left">
                                <div className="i-container">
                                    <Call className={"i"} />
                                </div>
                            </div>
                            <div className="mini-flex-right">
                                <h5><a href="tel: 8689868867"> +91 8689868867</a></h5>
                            </div>
                        </div>

                    </div>{/* ***  Section left end  **** */}



                    <div className="section-right">
                        <h3>Send a Message</h3>
                        <form onSubmit={sendEmail} method="POST">
                            <div className="form-row">
                                <div className="form-group">
                                    <input type="text" name="fname" placeholder="First Name" autoComplete='off' />
                                </div>
                                <div className="form-group">
                                    <input type="text" name="lname" placeholder="Last Name" autoComplete='off' />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <input type="email" name="email" placeholder="Email" autoComplete='off' />
                                </div>
                                <div className="form-group">
                                    <input type="text" name="phone" placeholder="Mobile no" autoComplete='off' />
                                </div>
                            </div>
                            
                            <div className="form-group">
                               <textarea cols="10" rows="2" className="w-100" name="message" placeholder=" Your Message" 
                               autoComplete='off'/>
                            </div>
                        
                            <button type="submit" className="button active">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
